import Axios from "../../../lib/Axios";

export const getActiveUserPhoneOtpList = async () => {
  const result = await Axios.get("user/admin/phone-otp/active");
  const payload = result?.data?.result || {};
  const items = Array.isArray(payload.items) ? payload.items : [];
  const count = Number.isFinite(payload.count) ? payload.count : items.length;

  return {
    data: items,
    totalRecords: count,
  };
};
